<template>
    <k-page background="bg-white">
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container class="py-10">
            <div class="max-w-3xl mx-auto">
                <h1 class="text-3xl font-bold mb-8">Identity verification</h1>
                <p class="text-sm mb-4">
                    To comply with AML and KYC requirements, please verify your identity by completing document verification.
                </p>
                    <k-button @click.native.prevent="openLink" :disabled="sessionURL === null">
                        Start verification
                    </k-button>
            </div>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import ProfileHeader from '@investor/components/profile/ProfileHeader'

export default {
    components: {
        ProfileHeader,
    },
    data () {
        return {
            sessionURL: null
        }
    },
    async mounted () {
        const session = await this.$post('start-verification')
        this.sessionURL = session.redirectURL
    },
    methods: {
        openLink() {
            window.open(this.sessionURL, '_blank')
            this.$trackGAEvent('documents', 'verificationDocumentsStart2');
        }
    }
}
</script>


